import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateLoadParameter,
} from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/UpdateSearchFields";
import customClearInvoiceHistoryFilters from "@tKgpco/Store/Data/InvoiceHistoy/Handler/CustomClearInvoiceHistoryFilters";

addToChainBefore(chain, DispatchUpdateLoadParameter, props => {
    const getInvoiceHistoryParams = props.getState().pages.orderHistory.getOrdersParameter;
    props.dispatch(customClearInvoiceHistoryFilters({ clearInvoiceHistoryFilters: false, getInvoiceHistoryParams }));
});
